module.exports = __webpack_public_path__ + "static/target-e3d35ba5f1e5215b6d3f8314a7e8eb03.jpg";